import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
    label: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
}, { name: 'account-label' });

type LabelSectionProps = {
    label: string;
    value: string;
}
export const LabelSection = ({ label, value }: LabelSectionProps) => {
    const classes = useStyles();
    return <div className={classes.label}>
        <strong>{label}</strong>
        <div>
            {value}
        </div>
    </div>;
}
